import { Circle, Fill, Icon, Stroke, Style } from "ol/style";

import { svgs } from "@/gis/GISApi"

let srcCounselingCenter = "data:image/svg+xml," + encodeURIComponent(svgs.srcCounselingCenter);

if (document && document.body && document.body.classList.contains("frauen")) {
  srcCounselingCenter = "data:image/svg+xml," + encodeURIComponent(svgs.srcCounselingCenterFrauen);
}

const srcActivated = "data:image/svg+xml," + encodeURIComponent(svgs.activated);

const srcLocation = "data:image/svg+xml," + encodeURIComponent(svgs.location);

const srcCounselingCenterRechtstraeger = "data:image/svg+xml," + encodeURIComponent(svgs.srcCounselingCenterRechtstraeger)

export const layerStyles = {
  ccPin: new Style({
    image: new Icon({
      //anchor: [0.5, 1],
      color: "#ffffff",
      opacity: 1,
      src: srcCounselingCenter
    })
  }),

  selectedPin: new Style({
    image: new Icon({
      //anchor: [0.5, 1],
      color: "#ffffff",
      opacity: 1,
      src: srcActivated
    })
  }),

  ccPinGericht: new Style({
    image: new Icon({
      color: "#ffffff",
      opacity: 1,
      src: srcCounselingCenterRechtstraeger
    })
  }),

  location: new Style({
    image: new Icon({
      anchor: [0.5, 0.5],
      color: "#ffffff",
      opacity: 1,
      src: srcLocation
    })
  }),

  radius: new Style({
    image: new Circle({
      radius: 4,
      fill: new Fill({
        color: "rgba(0, 0, 0, 0.5)"
      })
    }),
    fill: new Fill({
      color: "rgba(0, 0, 0, 0.1)"
    }),
    stroke: new Stroke({
      color: "rgba(0, 0, 0, 0.5)",
      width: 2
    })
  }),

  geolocation: new Style({
    image: new Circle({
      radius: 6,
      fill: new Fill({
        color: "rgba(70, 70, 70, 0.5)"
      }),
      stroke: new Stroke({
        color: "rgba(70, 70, 70, 1)",
        width: 3
      })
    })
  }),

  bundeslaender: [
    new Style({
      stroke: new Stroke({
        color: '#7C7F80',
        width: 3,
      })
    }),
    new Style({
      fill: new Fill({
        color: 'white'
      })
    })
  ],

  bezirke: new Style({
    stroke: new Stroke({
      color: '#E8EAE9',
      width: 1,
    })
  }),


  /*cluster: new Style({
    image: new Circle({
      radius: 10,
      stroke: new Stroke({
        color: '#870038',
      }),
      fill: new Fill({
        color: '#870038',
      }),
    }),
    text: new Text({
      text: size.toString(),
      fill: new Fill({
        color: '#fff',
      }),
    }),
  })*/

};
